<template>
  <div id="app">

    <v-style v-if="$root.additionalCss">
      {{ $root.additionalCss }}
    </v-style>
    <svg-symbols />
    <loading :loading="$root.loading" :lines="10"></loading>
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-drawer">
      <sidebar />
      <main class="mdl-layout__content">
        <div class="page-content">
          <router-view :key="$route.fullPath" />
        </div>
      </main>
      </div>
  </div>
</template>

<style lang="scss">
@import './scss/app';
</style>

<script>
import loading from './components/Loading'
import sidebar from './components/Sidebar'
import svgSymbols from './components/SvgSymbols'

export default {
  components: {
    loading,
    sidebar,
    svgSymbols
  },
  methods: {
    logout () {
      this.$store.commit('logout')
      window.location.href = 'http://ec2-3-8-147-136.eu-west-2.compute.amazonaws.com:9011/samlv2/logout/5f99b684-9d6a-4bcf-9a90-605cdb71fae2'
    }
  },
  mounted () {
    let token = localStorage.getItem('accessToken')

    if (token) {
      this.$store.commit('accessToken', token)
    }
  }
}
</script>
